module.exports = __webpack_public_path__ + "img/streamedby.0965e10.svg";